<template>
  <div class="p-fluid">
    <div class="p-col-12 p-lg-12">
      <div class="card card-w-title">
        <div class="manager-title-custom">{{ title }}</div>
        <!-- <div class="note">(*) Nội dung không được bỏ trống</div> -->
        <formEdit
          :key="componentKey"
          :mode="mode"
          :company_id="company_id"
          @company="changeCompany"
          @save="saveData"
          :model="models"/>
      </div>
    </div>
  </div>
</template>
    
<script>
// import Config from '../../../config/index'
import formEdit from './add'
import ApiRepository from "@/core/ApiRepository";
export default {
  components: {
    formEdit
  },
  data() {
    return {
      users: null,
      validationErrors: [],
      title: "Công Thức Tính",
      mode: 'add',
      models: {},
      componentKey: 0,
      accountID: '',
      page_transaction:null,
      formula_id: null,
      company_id: null
    }
  },
  created() {
    this.$set(this,'company_id', (this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN) ? this.$store.getters?.company_id : null);
    console.log("fksdhfkdsfhklds");
  },
  watch: {
    async "this.$store.getters.controllers"() {
      console.log(this.$store.getters.controllers);
      this.componentKey++;
    },
    async "company_id"() {
      // if ((this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN)) {
      // }
      await this.getData();
    },
    "$store.getters.company_id"() {
      if ((this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN)) {
        this.$set(this,'company_id', (this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN) ? this.$store.getters?.company_id : null);
      }
    },
  },
  async mounted () {
    this.mode = this.$route.name === 'editformula' ? 'edit' : this.mode;
    this.title = this.mode === 'edit' ? 'Công Thức Tính' : this.title;
    if (!this.$commonFuction.isEmpty(this.$route.query)){
      if (!this.$commonFuction.isEmpty(this.$route.query.company_id)){
        this.company_id = this.$route.query.company_id;
        // await this.getData();
      } else {
        await this.getData();
      }
    } else {
      await this.getData();
    }
  },
  methods: {
    async changeCompany(value) {
      this.company_id = value;
    },
    async saveData(params) {
      var that = this;
      var company_id = params?.company ? params.company.id : null;
      if ((that.$store.getters?.type != that.$constants.TYPE_USER.SUPPER_ADMIN)) {
        company_id = that.$store.getters?.company_id;
      }
      let objects = {
        company_id: company_id,
        value: params.value,
        tick_arr: params.tick_arr,
        type: params.type,
        points: params.points,
        matrix: params.matrix,
        criteria_id_col: params.criteria_id_col,
        criteria_id_row: params.criteria_id_row,
        colors: params.colors,
        code_exist: params.code_exist,
        recalculation : params.recalculation
      }
      this.company_id = params?.company ? params.company.id : null;
      var token = that.$store.getters.token ? that.$store.getters.token : null
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        objects.id = this?.formula_id;
        await ApiRepository.post("/_api/formula/edit", objects, {headers}).then(async function (res) {
          if (res.status === 200) {
            that.redirectEdit();
          } else {
            if (res.message == 'MATRIX_MAX_LENGTH_ERR') {
              console.log(res.message);
            }
            that.$toast.add({
                severity: 'error',
                summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                detail: res.message,
                life: 3000
            });
            that.$commonFuction.is_loading(false);
          }
          if ((that.$store.getters?.type != that.$constants.TYPE_USER.SUPPER_ADMIN)) {
            that.company_id = that.$store.getters?.company_id;
          }
        }).catch(err => {
          console.log('errorerrorerrorerror', err.response.data.message);
          that.$toast.add({
              severity: 'error',
              summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
              detail: err.response.data.message,
              life: 3000
          });
          that.$commonFuction.is_loading(false);
        })
      }
    },
    async redirectEdit() {
      var that = this;
      that.$commonFuction.is_loading(false);
      that.$toast.add({ severity: 'success', summary: 'Success', detail: 'Lưu dữ liệu thành công', life: 3000 })
      this.getData();
    },
    async getData() {
      var company_id = this.company_id ?? null;
      if(this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN){
        company_id = this.$store.getters.company_id ?? null;
      }
      if (company_id) {
        var token = this.$store.getters.token ? this.$store.getters.token : null
        if(token){
          const headers = {
            "Authorization": "Bearer "+token,
          };
          var {data} = await ApiRepository.post("/_api/formula/detail", {company_id: company_id}, {headers});
          var value = data.data;
          this.formula_id = value?.dataValues?.id ?? null;
          this.models = value;
        }
      }
    },
  },
  apollo: {
    
  }
}
</script>

<style lang="scss">
  .manager-title-custom{
    color: #1D3118;
    font-size: 18px;
    margin-bottom: 16px;
    padding-bottom: 10px;
    border-bottom: 1px solid #EEEEEE;
    font-weight: 700;
  }
.p-inputnumber-buttons-stacked {
  .p-inputnumber-button-group {
    .p-button.p-button-icon-only { padding: 0 !important; }
  }
}
.note{ letter-spacing: 0px; color: #707070; margin-bottom: 24px; padding-top: 10px;}
.p-formgrid { margin: 0;
  .p-panel-header {color: #000000; font-size: 18px; font-weight: bold; background: #EEEEEE;}
  .p-card-field{ padding: 24px;
    .p-field{
      .p-col-fixed { width: 300px; display: inline-block !important; margin: 0;}
      .p-col-width{width:500px !important; border-radius: 5px;
        &.disabled{background: #EEEEEE; border: 0 none; padding: 8px 10px;}
        .file-select{margin: 0;
          input[type="file"]{display: none;}
          .select-button{display: inline-block; cursor: pointer; background: transparent; border-radius: 5px;  color: #000000; font-size: 13px; padding: 3px 16px;  border: 1px solid #B4B4B4;}
        }
        &.pac-target-input{ height: 80px;  word-break: break-all; overflow-wrap: break-word;  resize: none;}
      }
      .box-images{ margin: 0; margin-top: 10px; position: relative;
        .item-img{width: 133px; height: 150px;  margin-right: 8px; margin-bottom: 8px; display: inline-flex; position: relative;
          img{max-width: 100%; height: auto;margin: 0 auto; object-fit: contain; padding: 5px;}
          .button-clear{border-radius: 5px; width: 24px; height: 24px; background: #F5564E; float: right; cursor: pointer; position: absolute; right: 0px;
            img{vertical-align: top;}
          }
        }
      }
      .p-invalid{display: block;}
    }
  }
  .fixed-bottom-toolbar{background: transparent; border: 0 none; margin-top: 22px; border-top: 1px solid #B4B4B4; padding: 0; padding-top: 30px;
    .p-button{width: auto; margin-right: 8px;
      &:last-child{margin-right: 0;}
    }
  }
}
</style>